module.exports = __webpack_public_path__ + "static/media/SensorsScreen.f7f7ace9.png";